export const getAddressArray = (location) => {
	const formattedAddress = location?.['response-formattedAddress']?.value;

	const addressParts = (formattedAddress || '')
		.split(',')
		.slice(0, -1);

	return [
		...addressParts.slice(0, -2),
		addressParts.slice(addressParts.length - 2).join(', ')
	];
};
